import classNames from 'classnames';
import styles from './step-indicator.module.scss';

export interface StepIndicatorProps {
  /** The class name to apply */
  className?: string;
  /** The currently active item */
  currentItem?: number;
  /** Indicates whether to fill previous items */
  filled?: boolean;
  /** The total item count */
  itemCount?: number;
}

const StepIndicator = ({
  className,
  currentItem = 1,
  filled = false,
  itemCount = 1,
}: StepIndicatorProps) => {
  return (
    <ul
      className={classNames(styles.component, className, {
        [styles.isFilled]: filled,
      })}
    >
      {Array(itemCount)
        .fill(0)
        .map((_page, pageIndex) => (
          <li
            key={pageIndex}
            className={classNames(styles.item, {
              [styles.isActive]: pageIndex === currentItem - 1,
              [styles.isPrevious]: pageIndex < currentItem - 1,
            })}
          />
        ))}
    </ul>
  );
};

StepIndicator.displayName = 'StepIndicator';

export default StepIndicator;
